/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { forwardRef, useState } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import MenuItem from "@mui/material/MenuItem";
import Link from "@mui/material/Link";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ClearIcon from "@mui/icons-material/Clear";

// custom styles for the NotificationItem
import menuItem from "utils/Items/NotificationItem/styles";
import { Box, IconButton, Stack } from "@mui/material";
import TooltipLight from "utils/TooltipLight";

const NotificationItem = forwardRef(({ icon, title, displayClear, onClear, ...rest }, ref) => {
  const [hover, setHover] = useState(false);
  return (
    <Stack
      direction="row"
      alignItems="center"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <MenuItem {...rest} ref={ref} sx={(theme) => menuItem(theme, rest.sx)}>
        <MDBox
          component={rest?.component || Link}
          py={0.5}
          display="flex"
          alignItems="center"
          lineHeight={1}
        >
          <MDTypography variant="body1" color="secondary" lineHeight={0.75}>
            {icon}
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" sx={{ ml: icon ? 1 : 0 }}>
            {title}
          </MDTypography>
        </MDBox>
      </MenuItem>
      <Box width="30px">
        {displayClear && hover && (
          <TooltipLight title="Clear" placement="left">
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onClear();
              }}
              sx={{ mb: "0.5rem" }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </TooltipLight>
        )}
      </Box>
    </Stack>
  );
});

// Typechecking props for the NotificationItem
NotificationItem.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};

export default NotificationItem;
